"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.utxoSelect = void 0;
const coinselect_1 = __importDefault(require("coinselect"));
const split_1 = __importDefault(require("coinselect/split"));
/**
 * Returns necessary utxo inputs & outputs for a desired tx at a given fee with OP_RETURN data considered if provided
 *
 * _opReturnData is filtered out of the return payload as it is added during transaction signing_
 */
const utxoSelect = (input) => {
    var _a;
    const utxos = input.utxos.map((x) => ({ ...x, value: Number(x.value) }));
    const extraOutput = input.opReturnData ? [{ value: 0, script: input.opReturnData }] : [];
    const result = (() => {
        if (input.sendMax) {
            const outputs = [{ address: input.to }, ...extraOutput];
            return (0, split_1.default)(utxos, outputs, Number(input.satoshiPerByte));
        }
        const outputs = [{ value: Number(input.value), address: input.to }, ...extraOutput];
        return (0, coinselect_1.default)(utxos, outputs, Number(input.satoshiPerByte));
    })();
    return { ...result, outputs: (_a = result.outputs) === null || _a === void 0 ? void 0 : _a.filter((o) => !o.script) };
};
exports.utxoSelect = utxoSelect;
